import { create } from "../../../../../common/utils/zustand_state_manager";
import { TreinamentoDropDown } from "../../../domain/models/treinamento_dropdown";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CargoDropDown } from "../../../../../common/domain/models/cargo_dropdown";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { TreinamentoFuncionarioData } from "../../../domain/models/treinamento_funcionario_data";
import { TreinamentoFuncionarioAssinatura } from "../../../domain/models/treinamento_funcionario_assinatura";
import { TreinamentoFuncionarioInstrutor } from "../../../domain/models/treinamento_funcionario_instrutor";
import { TreinamentoFuncionarioLocal } from "../../../domain/models/treinamento_funcionario_local";

/**
 * useTreinamentoFuncionarioCadastroFilters
 */

type State = {
  treinamentos: TreinamentoDropDown[] | null,
  cargos: CargoDropDown[] | null,
  centroCustos: CentroCustoDropDown[] | null,
  selectedCargoIds: number[],
  selectedCentroCustoIds: number[],
  datas: TreinamentoFuncionarioData[] | null,
  assinaturas: TreinamentoFuncionarioAssinatura[] | null,
  instrutores: TreinamentoFuncionarioInstrutor[] | null,
  locais: TreinamentoFuncionarioLocal[] | null,
  FornecedorPesquisa: number,
};

type Actions = {
  setTreinamentos: SetFunction<TreinamentoDropDown[]>,
  setCargos: SetFunction<CargoDropDown[]>,
  setCentroCustos: SetFunction<CentroCustoDropDown[]>,
  setSelectedCargoIds: SetFunction<number[] | null>,
  setSelectedCentroCustoIds: SetFunction<number[] | null>,
  setDatas: SetFunction<TreinamentoFuncionarioData[] | null>,
  setAssinaturas: SetFunction<TreinamentoFuncionarioAssinatura[] | null>,
  setInstrutores: SetFunction<TreinamentoFuncionarioInstrutor[] | null>,
  setLocais: SetFunction<TreinamentoFuncionarioLocal[] | null>,
  setFornecedorPesquisa: SetFunction<number>,
};

export const useTreinamentoFuncionarioCadastroFilters = create<State & Actions>((set) => ({
  treinamentos: null,
  cargos: null,
  centroCustos: null,
  selectedCargoIds: [],
  selectedCentroCustoIds: [],
  datas: null,
  assinaturas: null,
  instrutores: null,
  locais: null,
  FornecedorPesquisa: 0,
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setTreinamentos: vfn => SetFunctionImpl(set, 'treinamentos', vfn),
  setCargos: vfn => SetFunctionImpl(set, 'cargos', vfn),
  setCentroCustos: vfn => SetFunctionImpl(set, 'centroCustos', vfn),
  setSelectedCargoIds: vfn => SetFunctionImpl(set, 'selectedCargoIds', vfn),
  setSelectedCentroCustoIds: vfn => SetFunctionImpl(set, 'selectedCentroCustoIds', vfn),
  setDatas: vfn => SetFunctionImpl(set, 'datas', vfn),
  setAssinaturas: vfn => SetFunctionImpl(set, 'assinaturas', vfn),
  setInstrutores: vfn => SetFunctionImpl(set, 'instrutores', vfn),
  setLocais: vfn => SetFunctionImpl(set, 'locais', vfn),
}));